export default "__VITE_ASSET__Cmcw0QkE__"